import { Grid as BaseGrid, styled } from '@mui/material'

export const Grid = styled(BaseGrid)`
  width: 100%;
`
